module.exports = __webpack_public_path__ + "img/smiley-happy.8fa685e4.svg";